var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isOpen
    ? _c("div", { staticClass: "Cookie" }, [
        _c(
          "div",
          { staticClass: "Cookie__content" },
          [
            _vm._t("message", function () {
              return [
                _vm._v(
                  "Like most websites we use cookies to improve your experience. By use of this site we will assume your acceptance"
                ),
              ]
            }),
            _vm._v(" "),
            _c("button", { on: { click: _vm.accept } }, [_vm._v("Accept")]),
            _vm._v(" "),
            _vm.buttonLink
              ? _c(
                  "router-link",
                  {
                    attrs: {
                      to: _vm.buttonLink,
                      rel: "noopener",
                      "aria-label": "Cookies read more",
                    },
                  },
                  [_vm._v("Read more")]
                )
              : _vm._e(),
          ],
          2
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }